import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
type ButtonProps = {
  children: React.ReactNode;
  className?: string;
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'lg';
  arrow?: boolean;
  href?: string;
  target?: '_blank';
  rel?: string;
  onClick?: () => void;
  ariaLabel?: string;
};
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'lg',
  arrow = false,
  href,
  target,
  rel,
  onClick,
  ariaLabel
}: ButtonProps) {
  const styles = {
    primary: 'bg-mineral text-navy border-2 border-gold shadow-lg shadow-black/40 transition-[background-color,transform] hover:bg-mineral-hover active:scale-[0.98]',
    secondary: 'bg-steel text-white border border-gold/40 transition-[background-color,transform] hover:bg-navy-soft active:scale-[0.98]',
    outline: 'border-2 border-gold bg-transparent text-mineral transition-colors hover:bg-steel'
  };
  const sizes = {
    sm: 'px-5 py-3 text-sm',
    lg: 'px-6 py-4 text-sm sm:px-10 sm:py-5 sm:text-base'
  };
  const classes = `inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg font-extrabold uppercase tracking-wide duration-150 ease-out focus:outline-none focus-visible:ring-4 focus-visible:ring-mineral/50 ${styles[variant]} ${sizes[size]} ${className}`;
  if (href) {
    return <a href={href} target={target} rel={rel} className={classes} aria-label={ariaLabel} data-id="element-275" data-mp="omivi98qbbjg">
        {children}
        {arrow && <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-276" data-mp="12l8vpxquhrc1" />}
      </a>;
  }
  return <button type="button" onClick={onClick} className={classes} aria-label={ariaLabel} data-id="element-277" data-mp="xmo1cey9y1vi">
      {children}
      {arrow && <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-278" data-mp="17elgtxwbfg01" />}
    </button>;
}